import React from "react";
import { Link as Link2 } from "react-router";
import { hasPermission } from "../auth/Auth";

export default class Link extends React.Component {

    render() {

        let allowed = true;

        if (this.props.permission === true) {
            allowed = true;
        } else if (this.props.permission === false) {
            allowed = false;
        } else if (typeof this.props.permission === "undefined") {
            allowed = true;
        } else {
            if (typeof this.props.permission !== "boolean" && !hasPermission(this.props.permission)) {
                allowed = false;
            }
        }

        if (!allowed) {
            if (this.props.textIfNoAccess === true) {
                return <span>{this.props.children}</span>;
            }
            return <span />;
        }

        return (
            <Link2 to={this.props.to} className={this.props.className} style={{ marginRight: "5px" }}>
                {this.props.children}
            </Link2>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/base/Link.js